export const QUESTION = 'Select your goal'

export const OPTION_VALUES = {
  BOOST_MOOD: 'boost_mood',
  RELIEVE_STRESS_AND_ANXIETY: 'relieve_stress_and_anxiety',
  GET_RID_OF_BRAIN_FOG: 'get_rid_of_brain_fog',
  ALL_THAT_WAS_MENTIONED: 'all_that_was_mentioned',
}
